export const TIME_FILTERS = ["today", "week", "month"] as const;
export type TimeFilter = (typeof TIME_FILTERS)[number];

export interface DateRange {
  startDate: string;
  endDate: string;
}

/**
 * Converts a time filter string to a date range for database queries.
 * Uses server's local timezone for date boundaries.
 *
 * @param timeFilter - The time filter option (today, week, month)
 * @returns A DateRange object with ISO timestamp strings, or undefined if no filter
 */
export function convertTimeFilterToDateRange(
  timeFilter?: TimeFilter
): DateRange | undefined {
  if (!timeFilter) {
    return undefined;
  }

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  let startDate: Date;
  let endDate: Date;

  switch (timeFilter) {
    case "today": {
      // From start of today to now
      startDate = today;
      endDate = now;
      break;
    }
    case "week": {
      // From 7 days ago (start of day) to now
      const weekAgo = new Date(today);
      weekAgo.setDate(weekAgo.getDate() - 7);
      startDate = weekAgo;
      endDate = now;
      break;
    }
    case "month": {
      // From 30 days ago (start of day) to now
      // Note: Uses 30 days, not calendar month
      const monthAgo = new Date(today);
      monthAgo.setDate(monthAgo.getDate() - 30);
      startDate = monthAgo;
      endDate = now;
      break;
    }
    default:
      return undefined;
  }

  return {
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  };
}
